/* ============================================================
   STENS — Dealer Detail (tam bagimsiz surum)
   /pages/dealer?country=tr gibi URL'lerde calisir.
   CSS + font dahil her seyi kendisi enjekte eder; Liquid'de
   degisiklik GEREKMEZ. Veri: dealers-data.js (STENS_DEALERS_DATA).
   ============================================================ */
(function() {
  'use strict';

  /* ---------- Stil enjeksiyonu (tek sefer) ---------- */
  function injectStyles() {
    if (document.getElementById('sdd-styles')) return;

    if (!document.querySelector('link[href*="family=Syne"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,700&family=Syne:wght@700;800&display=swap';
      document.head.appendChild(l);
    }

    var css = ''
    + '.sdd{--y:#E4C100;--ink:#0A0A0A;--cream:#F4F2EE;--bd:#E4E0D6;--mut:#6F6A5F;font-family:"DM Sans",system-ui,sans-serif;-webkit-font-smoothing:antialiased;background:var(--cream)}'
    + '.sdd h1,.sdd h2,.sdd h3,.sdd .sdd-num{font-family:"Syne","DM Sans",sans-serif}'
    + '.sdd .sdd-wrap{width:min(1400px,100%);margin:0 auto;padding-left:clamp(1.25rem,4vw,2.5rem);padding-right:clamp(1.25rem,4vw,2.5rem)}'
    + '.sdd .sdd-eyebrow{display:inline-flex;align-items:center;gap:.6rem;font-size:.66rem;font-weight:700;letter-spacing:.24em;text-transform:uppercase;color:var(--y)}'
    + '.sdd .sdd-eyebrow::before{content:"";width:26px;height:2px;background:var(--y)}'
    + '.sdd .sdd-eyebrow--plain::before{display:none}'
    + '.sdd .sdd-ico{display:inline-flex;align-items:center;justify-content:center;color:var(--y);flex-shrink:0}'
    + '.sdd .sdd-ico svg{width:15px;height:15px}'
    + '.sdd .sdd-btn{display:inline-flex;align-items:center;gap:.6rem;padding:.85rem 1.5rem;background:var(--y);color:var(--ink);font-size:.66rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;text-decoration:none;border:none;cursor:pointer;border-radius:4px;transition:transform .3s ease,box-shadow .3s ease}'
    + '.sdd .sdd-btn:hover{transform:translateY(-2px);box-shadow:0 10px 26px rgba(228,193,0,.35)}'
    + '.sdd .sdd-btn--ghost{background:transparent;border:1.5px solid var(--y);color:var(--y)}'
    + '.sdd .sdd-btn--ghost:hover{background:var(--y);color:var(--ink);box-shadow:none}'
    + '.sdd .sdd-hero{background:var(--ink);position:relative;overflow:hidden}'
    + '.sdd .sdd-hero-img{position:absolute;right:0;top:0;bottom:0;width:60%}'
    + '.sdd .sdd-hero-img img{width:100%;height:100%;object-fit:cover;display:block}'
    + '.sdd .sdd-hero-img::after{content:"";position:absolute;inset:0;background:linear-gradient(90deg,var(--ink) 0%,rgba(10,10,10,.3) 40%,transparent 65%)}'
    + '.sdd .sdd-hero-inner{position:relative;z-index:2;padding:clamp(1.4rem,3vw,2rem) 0 clamp(2.2rem,4.5vw,3.4rem)}'
    + '.sdd .sdd-crumb{display:flex;gap:.5rem;font-size:.6rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:rgba(255,255,255,.5);margin-bottom:clamp(1.4rem,3vw,2.2rem)}'
    + '.sdd .sdd-crumb a{color:rgba(255,255,255,.5);text-decoration:none}'
    + '.sdd .sdd-crumb a:hover{color:var(--y)}'
    + '.sdd .sdd-crumb .cur{color:#fff}'
    + '.sdd .sdd-hero h1{font-size:clamp(2.2rem,4.5vw,3.4rem);font-weight:800;line-height:1;letter-spacing:-.02em;text-transform:uppercase;color:#fff;margin:.9rem 0 1rem}'
    + '.sdd .sdd-hero-desc{color:rgba(255,255,255,.6);font-size:.86rem;line-height:1.7;max-width:340px;margin:0 0 1.6rem}'
    + '.sdd .sdd-hero-flag{font-size:.9rem}'
    + '.sdd .sdd-hero-stats{display:flex;gap:2.5rem;margin-bottom:1.4rem}'
    + '.sdd .sdd-hstat .sdd-num{font-size:1.8rem;font-weight:800;color:var(--y);line-height:1}'
    + '.sdd .sdd-hstat span{display:block;font-size:.56rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:rgba(255,255,255,.75);margin-top:.4rem}'
    + '.sdd .sdd-cities{display:flex;flex-wrap:wrap;gap:.6rem}'
    + '.sdd .sdd-city{padding:.55rem 1rem;border:1px solid rgba(255,255,255,.35);color:#fff;font-size:.6rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase}'
    + '.sdd .sdd-office-sec{padding:clamp(1.6rem,3vw,2.4rem) 0 0}'
    + '.sdd .sdd-office{background:var(--ink);border-radius:10px;display:flex;align-items:center;justify-content:space-between;gap:1.5rem;padding:1.3rem 1.7rem}'
    + '.sdd .sdd-office-left{display:flex;align-items:center;gap:1.1rem}'
    + '.sdd .sdd-office-icon svg{width:40px;height:40px}'
    + '.sdd .sdd-office-eyebrow{font-size:.56rem;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--y)}'
    + '.sdd .sdd-office h2{font-size:.95rem;font-weight:800;text-transform:uppercase;color:#fff;margin:.25rem 0 .5rem;letter-spacing:.02em}'
    + '.sdd .sdd-office-meta{display:flex;flex-wrap:wrap;gap:1.4rem;font-size:.76rem}'
    + '.sdd .sdd-office-meta a{color:rgba(255,255,255,.7);text-decoration:none;display:inline-flex;align-items:center;gap:.45rem}'
    + '.sdd .sdd-office-meta a:hover{color:var(--y)}'
    + '.sdd .sdd-partners{padding:clamp(2rem,4vw,3rem) 0 clamp(2rem,4vw,2.8rem)}'
    + '.sdd .sdd-partners-head{margin-bottom:1.4rem}'
    + '.sdd .sdd-partners-head h2{font-size:clamp(1.3rem,2.6vw,1.8rem);font-weight:800;text-transform:uppercase;color:#0F0F0F;margin:.5rem 0 0}'
    + '.sdd .sdd-dealer-grid{display:grid;grid-template-columns:1fr 1fr;gap:1.25rem}'
    + '.sdd .sdd-dealer{background:#fff;border:1px solid var(--bd);border-radius:8px;padding:1.1rem;display:grid;grid-template-columns:190px 1fr;gap:1.2rem;position:relative;transition:transform .3s ease,box-shadow .3s ease}'
    + '.sdd .sdd-dealer:hover{transform:translateY(-4px);box-shadow:0 18px 40px rgba(0,0,0,.08)}'
    + '.sdd .sdd-dealer-img{border-radius:6px;overflow:hidden;background:#1a1a1a;aspect-ratio:1/1}'
    + '.sdd .sdd-dealer-img img{width:100%;height:100%;object-fit:cover;display:block}'
    + '.sdd .sdd-dealer h3{font-size:.95rem;font-weight:800;text-transform:uppercase;color:#0F0F0F;margin:0 0 .2rem;padding-right:5rem}'
    + '.sdd .sdd-dealer-city{font-size:.58rem;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:var(--y);margin-bottom:.8rem}'
    + '.sdd .sdd-est{position:absolute;top:1.1rem;right:1.1rem;border:1px solid #C9C4B8;color:var(--mut);font-size:.54rem;font-weight:700;letter-spacing:.14em;padding:.35rem .6rem}'
    + '.sdd .sdd-dealer-meta{display:flex;flex-direction:column;gap:.55rem;margin-bottom:.9rem}'
    + '.sdd .sdd-dealer-meta>div,.sdd .sdd-dealer-meta a{display:flex;align-items:flex-start;gap:.55rem;font-size:.76rem;color:#3a3a3a;line-height:1.5;text-decoration:none}'
    + '.sdd .sdd-dealer-meta a:hover{color:#0F0F0F}'
    + '.sdd .sdd-dealer-meta .sdd-ico{margin-top:.1rem}'
    + '.sdd .sdd-dealer-foot{display:flex;align-items:center;justify-content:space-between;gap:1rem;flex-wrap:wrap}'
    + '.sdd .sdd-tags{display:flex;flex-wrap:wrap;gap:.45rem}'
    + '.sdd .sdd-tag{border:1px solid rgba(228,193,0,.6);color:#8a7500;background:rgba(228,193,0,.07);font-size:.52rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;padding:.35rem .55rem}'
    + '.sdd .sdd-view{display:inline-flex;align-items:center;gap:.5rem;border:1px solid #C9C4B8;background:#fff;color:#0F0F0F;font-size:.58rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;padding:.6rem 1rem;text-decoration:none;transition:border-color .25s ease}'
    + '.sdd .sdd-view:hover{border-color:var(--y)}'
    + '.sdd .sdd-notfound{text-align:center;padding:3rem 0}'
    + '.sdd .sdd-notfound h1{font-size:clamp(1.6rem,3vw,2.2rem);text-transform:uppercase;color:#0F0F0F;margin:0 0 .8rem}'
    + '.sdd .sdd-notfound p{color:var(--mut);margin:0 0 1.4rem}'
    + '.sdd .sdd-trust-sec{padding:0 0 clamp(1.6rem,3vw,2.2rem)}'
    + '.sdd .sdd-trust{background:var(--ink);border-radius:10px;display:grid;grid-template-columns:repeat(4,1fr);padding:1.6rem .6rem}'
    + '.sdd .sdd-trust-item{display:flex;align-items:flex-start;gap:.85rem;padding:0 1.3rem}'
    + '.sdd .sdd-trust-item+.sdd-trust-item{border-left:1px solid rgba(255,255,255,.12)}'
    + '.sdd .sdd-trust-item .sdd-ico svg{width:34px;height:34px}'
    + '.sdd .sdd-trust-item h3{font-size:.68rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#fff;margin:0 0 .35rem}'
    + '.sdd .sdd-trust-item p{font-size:.68rem;color:rgba(255,255,255,.5);line-height:1.55;margin:0}'
    + '.sdd .sdd-cta-sec{padding:0 0 clamp(2.4rem,5vw,3.6rem)}'
    + '.sdd .sdd-cta{position:relative;background:var(--ink);border-radius:12px;overflow:hidden;display:grid;grid-template-columns:1fr 1fr;min-height:280px}'
    + '.sdd .sdd-cta-text{position:relative;z-index:2;padding:clamp(1.8rem,3.5vw,3rem);display:flex;flex-direction:column;justify-content:center;align-items:flex-start}'
    + '.sdd .sdd-cta h2{font-size:clamp(1.5rem,3vw,2.2rem);font-weight:800;line-height:1.1;text-transform:uppercase;color:#fff;margin:.7rem 0 .9rem;max-width:24rem}'
    + '.sdd .sdd-cta p{color:rgba(255,255,255,.55);font-size:.8rem;line-height:1.65;max-width:360px;margin:0 0 1.3rem}'
    + '.sdd .sdd-cta-img{position:absolute;right:0;top:0;bottom:0;width:58%}'
    + '.sdd .sdd-cta-img img{width:100%;height:100%;object-fit:cover;display:block}'
    + '.sdd .sdd-cta-img::after{content:"";position:absolute;inset:0;background:linear-gradient(90deg,var(--ink) 0%,rgba(10,10,10,.2) 45%,transparent 70%)}'
    + '@media (max-width:768px){'
    + '.sdd .sdd-dealer{grid-template-columns:1fr}'
    + '.sdd .sdd-dealer h3{padding-right:0}'
    + '.sdd .sdd-est{position:static;display:inline-block;margin-bottom:.6rem}'
    + '}'
    + '@media (max-width:980px){'
    + '.sdd .sdd-hero-img{position:relative;width:100%;height:220px}'
    + '.sdd .sdd-hero-img::after{background:linear-gradient(0deg,var(--ink) 0%,transparent 55%)}'
    + '.sdd .sdd-dealer-grid{grid-template-columns:1fr}'
    + '.sdd .sdd-office{flex-direction:column;align-items:flex-start}'
    + '.sdd .sdd-trust{grid-template-columns:1fr 1fr;row-gap:1.4rem}'
    + '.sdd .sdd-trust-item:nth-child(3){border-left:0}'
    + '.sdd .sdd-cta{grid-template-columns:1fr}'
    + '.sdd .sdd-cta-img{position:relative;width:100%;height:220px;order:-1}'
    + '.sdd .sdd-cta-img::after{background:linear-gradient(0deg,var(--ink) 0%,transparent 50%)}'
    + '}'
    + '@media (max-width:560px){'
    + '.sdd .sdd-dealer{grid-template-columns:1fr}'
    + '.sdd .sdd-dealer h3{padding-right:0}'
    + '.sdd .sdd-est{position:static;display:inline-block;margin-bottom:.6rem}'
    + '.sdd .sdd-trust{grid-template-columns:1fr}'
    + '.sdd .sdd-trust-item{border-left:0!important}'
    + '.sdd .sdd-hero-stats{gap:1.6rem}'
    + '}';

    var st = document.createElement('style');
    st.id = 'sdd-styles';
    st.textContent = css;
    document.head.appendChild(st);
  }

  /* ---------- Yardimcilar ---------- */
  function stensAsset(p){ if(!p) return p; if(/^(https?:)?\/\//.test(p)||p.charAt(0)==='/') return p; var f=String(p).split('/').pop(); return (window.STENS_ASSET_BASE||'')+f; }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var IC = {
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4l2 5-2.5 1.5a12 12 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M3 7l9 6 9-6"/></svg>',
    building: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 21h16M6 21V4h8v17M14 9h4v12"/><path d="M8.5 7h1M11 7h1M8.5 10h1M11 10h1M8.5 13h1M11 13h1M16 12h.8M16 15h.8"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 3v6c0 5.5-3.5 8.5-8 9.5C7.5 20.5 4 17.5 4 12V6l8-3z"/><path d="M9 12l2 2 4-4"/></svg>',
    tools: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 7a4 4 0 0 1 5.5-3.7L16 6.8l1.2 1.2 3.5-3.5A4 4 0 0 1 15 10L7 18a2 2 0 0 1-3-3l8-8z"/><path d="M5 5l3 3"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/></svg>',
    gauge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="13" r="8"/><path d="M12 13l4-4"/><path d="M8.5 17.5h7"/></svg>'
  };

  var TRUST_ITEMS = [
    { icon: 'shield', title: 'Certified Installers', text: 'All dealers are trained and certified by STENS.' },
    { icon: 'tools',  title: 'Technical Support',   text: 'Direct engineering support and fitment guidance.' },
    { icon: 'box',    title: 'Quality Assured',     text: 'Genuine STENS products and warranty coverage.' },
    { icon: 'gauge',  title: 'Performance Focused', text: 'Engineered for real-world and track performance.' }
  ];

  function getCountryCode() {
    var params = new URLSearchParams(window.location.search);
    return (params.get('country') || '').toLowerCase();
  }

  function getRoot() {
    var root = document.getElementById('dealerRoot');
    if (!root) {
      root = document.createElement('div');
      root.id = 'dealerRoot';
      var host = document.querySelector('main') || document.body;
      host.appendChild(root);
    }
    root.classList.add('sdd');
    return root;
  }

  function loadCountryData() {
    if (window.STENS_DEALERS_DATA && window.STENS_DEALERS_DATA.countries) {
      return Promise.resolve(window.STENS_DEALERS_DATA.countries);
    }
    return fetch('data/dealers.json')
      .then(function(res) { if (!res.ok) throw new Error('load fail'); return res.json(); })
      .then(function(json) { return json.countries || {}; })
      .catch(function() { return {}; });
  }

  function renderNotFound(code) {
    getRoot().innerHTML = ''
      + '<section class="sdd-partners"><div class="sdd-wrap"><div class="sdd-notfound">'
      + '<h1>Country Not Found</h1>'
      + '<p>No STENS dealer information for "<strong>' + escapeHtml(code || '?') + '</strong>".</p>'
      + '<a href="/pages/dealers" class="sdd-btn">Browse All Regions &rarr;</a>'
      + '</div></div></section>';
  }

  function renderCountry(code, country) {
    var root = getRoot();
    document.title = country.name + ' Dealers \u2014 STENS';

    var dealers = country.dealers || [];
    var cities = dealers.map(function(d) { return d.city; }).filter(function(v, i, a) { return a.indexOf(v) === i; });

    var citiesPills = cities.map(function(c) { return '<span class="sdd-city">' + escapeHtml(c) + '</span>'; }).join('');

    var dealerCards = dealers.map(function(d) {
      var specs = (d.specialties || []).map(function(s) { return '<span class="sdd-tag">' + escapeHtml(s) + '</span>'; }).join('');
      var img = d.image ? '<img src="' + escapeHtml(stensAsset(d.image)) + '" alt="' + escapeHtml(d.name) + '" loading="lazy">' : '';
      var view = d.url ? '<a href="' + escapeHtml(d.url) + '" class="sdd-view">View Details &rarr;</a>' : '';
      return ''
        + '<article class="sdd-dealer">'
        +   '<div class="sdd-dealer-img">' + img + '</div>'
        +   '<div>'
        +     '<h3>' + escapeHtml(d.name) + '</h3>'
        +     '<div class="sdd-dealer-city">' + escapeHtml(d.city) + '</div>'
        +     (d.since ? '<span class="sdd-est">EST. ' + escapeHtml(d.since) + '</span>' : '')
        +     '<div class="sdd-dealer-meta">'
        +       (d.address ? '<div><span class="sdd-ico">' + IC.pin + '</span><span>' + escapeHtml(d.address) + '</span></div>' : '')
        +       (d.phone ? '<a href="tel:' + escapeHtml(String(d.phone).replace(/\s/g, '')) + '"><span class="sdd-ico">' + IC.phone + '</span>' + escapeHtml(d.phone) + '</a>' : '')
        +       (d.email ? '<a href="mailto:' + escapeHtml(d.email) + '"><span class="sdd-ico">' + IC.mail + '</span>' + escapeHtml(d.email) + '</a>' : '')
        +     '</div>'
        +     '<div class="sdd-dealer-foot">'
        +       (specs ? '<div class="sdd-tags">' + specs + '</div>' : '<span></span>')
        +       view
        +     '</div>'
        +   '</div>'
        + '</article>';
    }).join('');

    var trustItems = TRUST_ITEMS.map(function(t) {
      return '<div class="sdd-trust-item"><span class="sdd-ico">' + IC[t.icon] + '</span>'
        + '<div><h3>' + t.title + '</h3><p>' + t.text + '</p></div></div>';
    }).join('');

    var heroImage = country.image || 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1600&q=85&auto=format&fit=crop';
    var ctaImage = country.cta_image || 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1400&q=85&auto=format&fit=crop';

    root.innerHTML = ''
      + '<section class="sdd-hero">'
      +   '<div class="sdd-hero-img" aria-hidden="true"><img src="' + escapeHtml(stensAsset(heroImage)) + '" alt="" loading="eager"></div>'
      +   '<div class="sdd-wrap"><div class="sdd-hero-inner">'
      +     '<nav class="sdd-crumb" aria-label="Breadcrumb"><a href="/">Home</a><span>/</span><a href="/pages/dealers">Dealers</a><span>/</span><span class="cur">' + escapeHtml(country.name) + '</span></nav>'
      +     '<span class="sdd-eyebrow">STENS Dealer Network <span class="sdd-hero-flag">' + (country.flag || '') + '</span></span>'
      +     '<h1>' + escapeHtml(country.name) + '</h1>'
      +     '<p class="sdd-hero-desc">' + escapeHtml(country.summary || '') + '</p>'
      +     '<div class="sdd-hero-stats">'
      +       '<div class="sdd-hstat"><div class="sdd-num">' + dealers.length + '</div><span>Authorized Dealers</span></div>'
      +       '<div class="sdd-hstat"><div class="sdd-num">' + cities.length + '</div><span>Cities</span></div>'
      +     '</div>'
      +     '<div class="sdd-cities">' + citiesPills + '</div>'
      +   '</div></div>'
      + '</section>'
      + '<section class="sdd-office-sec"><div class="sdd-wrap"><div class="sdd-office">'
      +   '<div class="sdd-office-left">'
      +     '<span class="sdd-ico sdd-office-icon">' + IC.building + '</span>'
      +     '<div>'
      +       '<div class="sdd-office-eyebrow">Regional Office</div>'
      +       '<h2>' + escapeHtml(country.regional_office || country.name + ' Office') + '</h2>'
      +       '<div class="sdd-office-meta">'
      +         (country.regional_phone ? '<a href="tel:' + escapeHtml(String(country.regional_phone).replace(/\s/g, '')) + '"><span class="sdd-ico">' + IC.phone + '</span>' + escapeHtml(country.regional_phone) + '</a>' : '')
      +         (country.regional_email ? '<a href="mailto:' + escapeHtml(country.regional_email) + '"><span class="sdd-ico">' + IC.mail + '</span>' + escapeHtml(country.regional_email) + '</a>' : '')
      +       '</div>'
      +     '</div>'
      +   '</div>'
      +   '<a href="/pages/contact" class="sdd-btn sdd-btn--ghost">Contact Office &rarr;</a>'
      + '</div></div></section>'
      + '<section class="sdd-partners"><div class="sdd-wrap">'
      +   '<div class="sdd-partners-head">'
      +     '<span class="sdd-eyebrow sdd-eyebrow--plain">Authorized Installers</span>'
      +     '<h2>' + dealers.length + ' Certified ' + (dealers.length === 1 ? 'Partner' : 'Partners') + ' in ' + escapeHtml(country.name) + '</h2>'
      +   '</div>'
      +   '<div class="sdd-dealer-grid">' + dealerCards + '</div>'
      + '</div></section>'
      + '<section class="sdd-trust-sec"><div class="sdd-wrap"><div class="sdd-trust">' + trustItems + '</div></div></section>'
      + '<section class="sdd-cta-sec"><div class="sdd-wrap"><div class="sdd-cta">'
      +   '<div class="sdd-cta-text">'
      +     '<span class="sdd-eyebrow sdd-eyebrow--plain">Become a STENS Dealer</span>'
      +     '<h2>Are you a tuner or<br>workshop in ' + escapeHtml(country.name) + '?</h2>'
      +     '<p>Join our authorized network. Wholesale pricing, technical support, marketing co-op funds and our 3-day fitment certification program.</p>'
      +     '<a href="/pages/contact" class="sdd-btn">Apply Now &rarr;</a>'
      +   '</div>'
      +   '<div class="sdd-cta-img" aria-hidden="true"><img src="' + escapeHtml(stensAsset(ctaImage)) + '" alt="" loading="lazy"></div>'
      + '</div></div></section>';
  }

  function init() {
    injectStyles();
    var code = getCountryCode();
    if (!code) { renderNotFound(null); return; }
    loadCountryData().then(function(countries) {
      var country = countries[code];
      if (!country) { renderNotFound(code); return; }
      renderCountry(code, country);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();